// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"ccc5c3f4","646":"b81061de"}[chunkId] + ".chunk.css";
};